/*
  Menu component styles.
*/

import { createStyles, makeStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

export const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      padding: theme.spacing(0.75),
      position: 'relative',
      minWidth: 'unset',

      '& svg path': {
        fill: variables.colorV2.button.contained.primary.icon.fill.default,
      },

      '&:hover, &[data-opened="true"]': {
        // backgroundColor: variables.color.primary.backgroundLighterGray,
        //TODO: remove borderWidth on data-opened=true
        // borderWidth: variables.borderWidth.sm,
        // borderColor: variables.color.primary.mainPurple,

        '& svg, & svg path': {
          fill: variables.colorV2.button.contained.primary.icon.fill.hover,
        },

        '& $menuTitle': {
          color: variables.colorV2.button.contained.primary.text.default,
        },
      },

      '&.MuiButton-containedSecondary': {
        '& svg': {
          stroke: variables.color.primary.white,
        },

        '&:hover, &[data-opened="true"]': {
          // backgroundColor: variables.color.secondary.blue,
        },
      },
    },

    menuTitle: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 0.75),
      textTransform: 'none',

      '& svg': {
        marginLeft: theme.spacing(1),
      },
    },

    paper: {
      border: `1px solid ${variables.colorV2.popupMenu.border.default}`,
      backgroundColor: variables.colorV2.popupMenu.background.default,
      borderRadius: '.8rem',
      boxShadow: '0 0.4rem 1.6rem rgba(0, 0, 0, 0.2)',
      minWidth: '24rem',
      padding: '.4rem 0',

      '&[data-anchor-y="bottom"]': {
        marginTop: variables.gap.xxs,
      },

      '&[data-anchor-y="top"]': {
        marginLeft: variables.gap.xxs,
      },
    },

    menuList: {
      padding: '0',
    },
  }),
);
